import { SignalBadge } from "./SignalBadge";

export default SignalBadge;
